import React, { useState, useEffect, useRef } from 'react';
import flatpickr from 'flatpickr'; // Import flatpickr
import 'flatpickr/dist/flatpickr.css'; // Import flatpickr CSS

const TimePickerWrapper = ({ onChange, value }) => {
  const [selectHour, setSelectHour] = useState(new Date());
  const [setIsOpen] = useState(false); // Track if the picker is open

  const inputRef = useRef(null); // Reference to the input element

  // const handleTimeChange = (e) => {
  //   const newTime = new Date(selectHour);
  //   const [hours, minutes] = e.target.value.split(':');
  //   newTime.setHours(hours);
  //   newTime.setMinutes(minutes);
  //   setSelectHour(newTime);
  // };

  useEffect(() => {
    // Initialize flatpickr on the input field when the component mounts
    if (inputRef.current) {
      const fp = flatpickr(inputRef.current, {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',  // Set 12-hour format with AM/PM (h:i K)
        time_24hr: true,     // Disable 24-hour format to use AM/PM
        minuteIncrement: 1,   // Minute step increment
        defaultDate: value || null, // Initialize with value prop
        onChange: (selectedDates, dateStr) => {
          onChange(dateStr); // Pass the selected time string (e.g., "14:30") to parent
        },
      });

      if (value) {
        fp.setDate(value, false);
      }

    }

    // Cleanup: Destroy the flatpickr instance when the component unmounts
    // return () => {
    //   if (inputRef.current) {
    //     inputRef.current._flatpickr.destroy(); // Destroy flatpickr instance
    //   }
    // };
  }, [value, onChange]);

  return (
    <div className="">
      <input
        type="text"
        ref={inputRef} // Attach the ref to the input
        className="form-control custom-time-picker"
        placeholder="Time"
        defaultValue={value || ''}
        // value={selectHour.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}
        // onFocus={() => setIsOpen(true)} 
        // onChange={handleTimeChange}
      />
    </div>
  );
};

export default TimePickerWrapper;
